var _rect, _path, _path2, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 25.5001L11.875 22.3334C10.8231 20.8401 10.3522 19.0143 10.5509 17.1985C10.7495 15.3827 11.604 13.7019 12.9539 12.4714C14.3039 11.2408 16.0565 10.5453 17.8828 10.5152C19.7092 10.4851 21.4837 11.1225 22.8735 12.3079C24.2632 13.4933 25.1726 15.1451 25.431 16.9533C25.6893 18.7616 25.2789 20.6019 24.2768 22.1291C23.2746 23.6562 21.7495 24.7651 19.9878 25.2477C18.2261 25.7303 16.3489 25.5533 14.7083 24.7501L10.5 25.5001",
    stroke: "#4F4F4F",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 16.3333C15.5 16.4438 15.5439 16.5497 15.622 16.6279C15.7002 16.706 15.8062 16.7499 15.9167 16.7499C16.0272 16.7499 16.1332 16.706 16.2113 16.6279C16.2894 16.5497 16.3333 16.4438 16.3333 16.3333V15.4999C16.3333 15.3894 16.2894 15.2834 16.2113 15.2053C16.1332 15.1272 16.0272 15.0833 15.9167 15.0833C15.8062 15.0833 15.7002 15.1272 15.622 15.2053C15.5439 15.2834 15.5 15.3894 15.5 15.4999V16.3333ZM15.5 16.3333C15.5 17.4383 15.939 18.4981 16.7204 19.2795C17.5018 20.0609 18.5616 20.4999 19.6667 20.4999M19.6667 20.4999H20.5C20.6105 20.4999 20.7165 20.456 20.7946 20.3779C20.8728 20.2997 20.9167 20.1938 20.9167 20.0833C20.9167 19.9727 20.8728 19.8668 20.7946 19.7886C20.7165 19.7105 20.6105 19.6666 20.5 19.6666H19.6667C19.5562 19.6666 19.4502 19.7105 19.372 19.7886C19.2939 19.8668 19.25 19.9727 19.25 20.0833C19.25 20.1938 19.2939 20.2997 19.372 20.3779C19.4502 20.456 19.5562 20.4999 19.6667 20.4999Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#C8C8C8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsappIcon.890950a048a9d970bd8dcbaf0b0ed9e6.svg";
export { ForwardRef as ReactComponent };